import { render } from "./BaseColumns.vue?vue&type=template&id=f32cd364&scoped=true"
const script = {}

import "./BaseColumns.vue?vue&type=style&index=0&id=f32cd364&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f32cd364"]])

export default __exports__